import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; // Navigation ke liye
import { FiTrendingUp, FiEye, FiPrinter } from 'react-icons/fi';
import config from '../../config/config';

export function DeliveryReport() {
  const [weightData, setWeightData] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate(); // Hook initialize karein

  const [filters] = useState({
    category: '',
    type: '',
    year: new Date().getFullYear()
  });

  const fetchWeightReport = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const { category, type, year } = filters;
      const response = await fetch(
        `${config.baseUrl}/api/reports/weight-head?year=${year}&category=${category}&type=${type}`,
        { headers: { 'Authorization': `Bearer ${token}` } }
      );
      if (!response.ok) throw new Error('Failed to fetch data');
      const data = await response.json();
      setWeightData(data);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWeightReport();
  }, [filters]);

  const handlePrint = (item) => {
    navigate('/reports/deliveryPrint', {
      state: {
        animalData: item,
        // Fallback to item details if global filters are empty
        category: filters.category || item.animal_type,
        cat_name: item.cat,
        type: filters.type || item.category,
        subCat: item.subcat,
        day: item.slaughtering_day

      }
    });
  };

  return (
    <div className="min-h-screen bg-slate-50/50 p-4 md:p-8">
      <div className="max-w-7xl mx-auto mb-8">
        <h1 className="text-3xl font-black text-slate-800 tracking-tight flex items-center gap-3">
          <div className="bg-indigo-700 p-2 rounded-xl text-white shadow-lg shadow-indigo-200">
            <FiTrendingUp size={24} />
          </div>
          Delivery Counter
        </h1>
      </div>

      <div className="max-w-7xl mx-auto bg-white rounded-[1rem] shadow-xl shadow-slate-200/60 border border-slate-100 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-left">
            <thead>
              <tr className="bg-indigo-800 border-b text-center text-white text-sm border-slate-100">
                <th className="px-6 py-2 font-black uppercase tracking-widest">S.No</th>
                <th className="px-6 py-2 font-black uppercase tracking-widest">Category</th>
                <th className="px-6 py-2 font-black uppercase tracking-widest">Sub Category</th>
                <th className="px-6 py-2 font-black uppercase tracking-widest text-center">Day</th>
                <th className="px-6 py-2 font-black uppercase tracking-widest text-right">Action</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {loading ? (
                <tr>
                  <td colSpan="4" className="py-20 text-center text-slate-400">Loading...</td>
                </tr>
              ) : weightData.map((item, index) => (
                <tr key={index} className="hover:bg-indigo-50/30 transition-colors group">
                  <td className="px-2 py-2 text-center text-sm font-bold text-slate-400">#{index + 1}</td>
                  <td className="px-2 py-2 text-center">
                    <span className="text-sm font-black text-slate-700">{item.cat || 'General'}</span>
                  </td>
                  <td className="px-2 py-2 text-center">
                    <span className="text-sm font-black text-slate-700 ">{item.subcat || 'General'}</span>
                  </td>
                  <td className="px-2 py-2 text-center">
                    <div className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-indigo-100 text-indigo-900 text-xs font-bold">
                      {item.slaughtering_day}
                    </div>
                  </td>
                  <td className="px-6 py-3 text-right">
                    <div className="flex justify-end gap-3">

                      {/* Print Button */}
                      <button
                        onClick={() => handlePrint(item)}
                        className="p-2 bg-slate-50 text-slate-600 rounded-lg hover:bg-slate-800 hover:text-white transition-all shadow-sm"
                        title="Print Report"
                      >
                        <FiPrinter size={18} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}